import { render, staticRenderFns } from "./FeaturedOffersLink.vue?vue&type=template&id=9ac054fe&lang=pug&"
import script from "./FeaturedOffersLink.vue?vue&type=script&lang=js&"
export * from "./FeaturedOffersLink.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedOffersLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ac054fe')) {
      api.createRecord('9ac054fe', component.options)
    } else {
      api.reload('9ac054fe', component.options)
    }
    module.hot.accept("./FeaturedOffersLink.vue?vue&type=template&id=9ac054fe&lang=pug&", function () {
      api.rerender('9ac054fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/featured-offers/FeaturedOffersLink.vue"
export default component.exports